import Vue from "vue";
import Swal from "sweetalert2";
import moment from "jalali-moment";
import { HIDE_MODAL } from "@/core/services/store/modal.module";
import { mapGetters } from "vuex";
import { GET_PROGRAM_FILE_URL } from "@/core/services/store/programs.module";
const eventHub = new Vue();

const persianNumbers = [
    /۰/g,
    /۱/g,
    /۲/g,
    /۳/g,
    /۴/g,
    /۵/g,
    /۶/g,
    /۷/g,
    /۸/g,
    /۹/g
  ],
  arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];

Vue.mixin({
  data: function() {
    return {
      eventHub: eventHub,
      maskTokens: {
        P: {
          pattern: /[0-9]|[\u06F0-\u06F9]|[\u0660-\u0669]/
        },
        N: {
          pattern: /[-]|[0-9]|[\u06F0-\u06F9]|[\u0660-\u0669]/
        },
        0: {
          pattern: /[0]|[\u06F0]|[\u0660]/
        },
        1: {
          pattern: /[1]|[\u06F1]|[\u0661]/
        },
        2: {
          pattern: /[2]|[\u06F2]|[\u0662]/
        },
        3: {
          pattern: /[3]|[\u06F3]|[\u0663]/
        },
        4: {
          pattern: /[4]|[\u06F4]|[\u0664]/
        },
        5: {
          pattern: /[5]|[\u06F5]|[\u0665]/
        },
        6: {
          pattern: /[6]|[\u06F6]|[\u0666]/
        },
        7: {
          pattern: /[7]|[\u06F7]|[\u0667]/
        },
        8: {
          pattern: /[8]|[\u06F8]|[\u0668]/
        },
        9: {
          pattern: /[9]|[\u06F9]|[\u0669]/
        }
      }
    };
  },
  computed: {
    ...mapGetters([
      "currentUserProperty",
      "currentUserCompany",
      "currentUserOperator",
      "currentUserPersonalInfo"
    ]),

    isCompanyOwner() {
      return this.currentUserProperty.id !== undefined;
    },
    isCompanyUser() {
      return this.currentUserCompany.id !== undefined;
    },
    isOperator() {
      return this.currentUserOperator.id !== undefined;
    },
    isWalletShared() {
      const { attributes } = this.currentUserCompany || {};
      return attributes
        ?.filter(item => {
          return item?.name === "IS_WALLET_SHARED";
        })
        .some(item => {
          return item.value === "1";
        });
    },
    showFinancialPart() {
      if (this.isCompanyOwner || this.isCompanyUser === false) {
        return true;
      }
      return this.isCompanyUser && this.isWalletShared === false;
    }
  },
  methods: {
    fixNumbers(string) {
      for (let i = 0; i < 10; i++) {
        string = string
          .replace(persianNumbers[i], i)
          .replace(arabicNumbers[i], i);
      }

      return string;
    },
    parseNumbers(string) {
      if (string.startsWith("-")) {
        return "-" + this.fixNumbers(string).replace(/\D/g, "");
      }
      return this.fixNumbers(string).replace(/\D/g, "");
    },
    parsePhone(phone) {
      return "+98" + this.parseNumbers(phone).substring(1);
    },
    prettyPhone(phone) {
      return phone ? "0" + phone.substring(3) : "-";
    },
    prettyTime(seconds) {
      if (seconds === undefined || isNaN(seconds)) return "00:00:00";

      let days = "";
      if (seconds > 86400) {
        days = seconds / 86400;
      }
      if (days) {
        days = parseInt(days) + " روز و ";
      }

      return days + new Date(seconds * 1000).toISOString().substr(11, 8);
    },
    prettyDate(date) {
      let day = ("0" + date.getDate()).slice(-2);
      let month = ("0" + (date.getMonth() + 1)).slice(-2);
      let year = date.getFullYear();
      let hours = date.getHours();
      let minutes = date.getMinutes();
      let seconds = date.getSeconds();

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    numberFormat(number) {
      if (number === undefined || number === "" || number === "NaN") return "-";
      if (typeof number == "string")
        number = parseFloat(number.replace(/[^0-9]/g, ""));
      if (Number.isNaN(number)) return "-";
      return number.toFixed().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    },
    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    hideModal() {
      this.$store.commit(HIDE_MODAL);
    },
    copyText(text, e) {
      this.$copyText(text).then(function() {
        let elem = e.target.children[0];
        if (elem === undefined) {
          elem = e.target;
        }
        elem.classList.remove("fa-copy");
        elem.classList.add("fa-check");

        setTimeout(function() {
          elem.classList.add("fa-copy");
          elem.classList.remove("fa-check");
        }, 2000);
      });
    },
    showError(error) {
      Swal.fire({
        title: "",
        text: error,
        icon: "error",
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonText: "بستن",
        cancelButtonColor: "#4554a0",
        heightAuto: false
      }).then(() => {});
    },
    showMessage(text) {
      Swal.fire({
        title: "",
        text: text,
        icon: "",
        showCancelButton: true,
        cancelButtonText: "بستن",
        cancelButtonColor: "#4554a0",
        heightAuto: false,
        showConfirmButton: false
      }).then(() => {});
    },
    disableBtn(elm) {
      elm.classList.add("spinner", "spinner-light", "spinner-right");
      elm.disabled = true;
    },
    enableBtn(elm) {
      elm.classList.remove("spinner", "spinner-light", "spinner-right");
      elm.disabled = false;
    },
    addOverlay(elm) {
      if (!elm) {
        return;
      }
      if (HTMLCollection.prototype.isPrototypeOf(elm)) {
        if (elm[0] === undefined) {
          return;
        }
        for (let i = 0; i < elm.length; i++) {
          elm[i].classList.add("overlay", "overlay-block");
          elm[i].firstChild.classList.add("overlay-wrapper");
          elm[i].innerHTML +=
            '<div class="overlay-layer bg-dark-o-10"><div class="spinner spinner-primary mr-5"></div></div>';
        }
      } else {
        elm.classList.add("overlay", "overlay-block");
        elm.firstChild.classList.add("overlay-wrapper");
        elm.innerHTML +=
          '<div class="overlay-layer bg-dark-o-10"><div class="spinner spinner-primary mr-5"></div></div>';
      }
    },
    removeOverlay(elm) {
      if (!elm) {
        return;
      }
      if (HTMLCollection.prototype.isPrototypeOf(elm)) {
        if (elm[0] === undefined) {
          return;
        }
        for (let i = 0; i < elm.length; i++) {
          elm[i].classList.remove("overlay", "overlay-block");
          elm[i].firstChild.classList.remove("overlay-wrapper");
          elm[i]
            .getElementsByClassName("overlay-layer")
            .forEach(e => e.remove());
        }
      } else {
        elm.classList.remove("overlay", "overlay-block");
        elm.firstChild.classList.remove("overlay-wrapper");
        elm.getElementsByClassName("overlay-layer").forEach(e => e.remove());
      }
    },
    formatDate(input, config = null, separator = " - ") {
      if (input === undefined) return "-";
      if (input === null) return "-";

      let date = isNaN(input) ? new Date(input) : input * 1000;

      config = config
        ? config
        : {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
          };

      return this.fixNumbers(
        new Intl.DateTimeFormat("fa-IR", config)
          .format(date)
          .replace(/،/g, separator)
      );
    },

    gDate(
      string,
      inputFormat = "YYYY-M-D HH:mm:ss",
      outputFormat = "YYYY/MM/DD HH:mm:ss"
    ) {
      return moment
        .from(this.fixNumbers(string), "fa", inputFormat)
        .format(outputFormat);
    },

    gFullName(user) {
      if (user === undefined) return "-";

      if (user.first_name || user.last_name) {
        return (user.first_name ?? "") + " " + (user.last_name ?? "");
      }

      return this.prettyPhone(user.cellphone);
    },
    sortArray(items) {
      // debugger
      items.sort(function(a, b) {
        return a.last_event - b.last_event;
      });
    },
    justNumber(e) {
      if (e.charCode >= 48 && e.charCode <= 57) {
        return true;
      } else {
        return e.preventDefault();
      }
    },
    notSpace(event) {
      if (event.charCode === 32 && event.target.value.length <= 0) {
        event.preventDefault();
      }
    },
    bytesToHuman(bytes) {
      const sizes = ["Bytes", "KB", "MB", "GB", "TB"];

      if (bytes === 0) return "0 Bytes";

      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);

      if (i === 0) return `${bytes} ${sizes[i]}`;

      return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`;
    },
    bytesToGig(bytes) {
      return bytes / Math.pow(2, 30);
    },
    getDuration(data, to = null) {
      if (to) {
        return parseInt((new Date(to).getTime() - new Date(data)) / 1000);
      }
      return parseInt((new Date().getTime() - new Date(data)) / 1000);
    },
    isProgramStopped(program) {
      return [3, 4].includes(program.last_event);
    },
    isProgramFailed(program) {
      return program.last_event === 2;
    },
    downloadFile(url, name = null) {
      if (name === null) {
        name = url.split("/").pop();
      }

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
    },
    setCookie(name, value, exdays) {
      const d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      document.cookie = `${name}=${value};expires=${d.toUTCString()}`;
    },
    getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    async posterUrl(program, path) {
      return await this.$store
        .dispatch(GET_PROGRAM_FILE_URL, {
          program: program,
          path: path
        })
        .then(url => {
          return url;
        })
        .catch(() => {
          return "";
        });
    }
  }
});
